import type { EnumUserRoles } from 'entities/Users'
import type { IAssignFlow, IAssignFlowResult } from './types'

export class SalesmsgAccessFlow implements IAssignFlow {
  constructor(
    private _getEmail: () => string | undefined,
    private _getRole: () => EnumUserRoles,
    private _createInvite: (
      email: string,
      role: EnumUserRoles,
      inboxIds: number[]
    ) => Promise<boolean>,
    private _onSuccess: () => void
  ) {}

  shouldIncludeMemberInNewInbox = (): boolean => false

  handleExistingInboxAssign = async (inboxIds: number[]): Promise<IAssignFlowResult> => {
    const email = this._getEmail()
    if (!email) return { success: false }

    const success = await this._createInvite(email, this._getRole(), inboxIds)
    if (success) {
      this._onSuccess()
    }
    return { success }
  }

  handleNewInboxCreated = async (inboxId: number): Promise<IAssignFlowResult> => {
    const email = this._getEmail()
    if (!email) return { success: false }

    const success = await this._createInvite(email, this._getRole(), [inboxId])
    if (success) {
      this._onSuccess()
    }
    return { success }
  }

  getExistingInboxSuccessToast = (): string => 'Salesmsg access approved'

  getNewInboxSuccessToast = (): string => 'Salesmsg access approved'
}
